import { useForm } from 'react-hook-form';
import { Input } from '../shared/Input';
import { Button } from '../shared/Button';

interface DatosNuevaPassword {
  nuevaPassword: string;
  confirmarPassword: string;
}

interface Props {
  onSubmit: (nuevaPassword: string) => void;
  enviando: boolean;
  error?: string;
}

/** BR-ID-04: primer login (o cuenta recien creada) — Cognito exige reemplazar la
 * contraseña temporal antes de emitir tokens (challenge NEW_PASSWORD_REQUIRED). */
export function NuevaPasswordForm({ onSubmit, enviando, error }: Props) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<DatosNuevaPassword>();

  return (
    <form
      onSubmit={handleSubmit((datos) => onSubmit(datos.nuevaPassword))}
      data-testid="nueva-password-form"
      className="flex flex-col gap-4"
    >
      <p className="text-xs text-admin-ink-muted leading-relaxed">
        Es tu primer ingreso. Define una nueva contraseña para continuar (mínimo 8 caracteres,
        con mayúscula, minúscula y número).
      </p>
      <Input
        label="Nueva contraseña"
        type="password"
        placeholder="••••••••"
        error={errors.nuevaPassword?.message}
        {...register('nuevaPassword', {
          required: 'La nueva contraseña es requerida',
          minLength: { value: 8, message: 'Debe tener al menos 8 caracteres' },
        })}
      />
      <Input
        label="Confirmar contraseña"
        type="password"
        placeholder="••••••••"
        error={errors.confirmarPassword?.message}
        {...register('confirmarPassword', {
          required: 'Confirma la nueva contraseña',
          validate: (valor) => valor === watch('nuevaPassword') || 'Las contraseñas no coinciden',
        })}
      />
      {error && <p className="text-xs text-danger" role="alert">{error}</p>}
      <Button type="submit" disabled={enviando} data-testid="nueva-password-submit-button">
        {enviando ? 'Guardando…' : 'Guardar y continuar'}
      </Button>
    </form>
  );
}
